import { Component, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Title, Meta } from '@angular/platform-browser';

import * as AOS from 'aos';
import { Router } from '@angular/router';
import { PdfService } from 'src/app/services/pdf.service';
import { HttpClient } from '@angular/common/http';
import { OperationService } from 'src/app/services/operation.service';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  title = 'GAIL Gas Limited - India’s Leading CGD Company';

  event_list: any;
  language: any;
  carouselMenuList: any;
  members: any;
  screenWidth: number;
  internalization: any;
  carouselList: any;
  pressReleaseNotes: any;

  pressReleaseNotesUpdated: any = []; // pushing 2 objects from pressReleaseNotes variable to display 1st 2 objcts
  EOI1: any;
  EOI4: any;
  EOI3: any;
  EOI2: any;
  EOIData: any = []

  constructor(private service: OperationService, private translateService: TranslateService, private titleService: Title, private metaTagService: Meta, private router: Router, private PdfService: PdfService, private http: HttpClient) {
    this.screenWidth = window.innerWidth;
    console.log(this.screenWidth)
    // this.getEoiDetails()
    this.eoiTableData()
  }

  ngOnInit(): void {
    this.PdfService.footer.emit();

    this.titleService.setTitle(this.title);
    this.metaTagService.updateTag(
      { name: 'description', content: 'GAIL Gas Limited - India’s Leading CGD Company' }
    );
    this.metaTagService.addTags([
      { name: 'keywords', content: '' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Infoneo' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '2021-03-08', scheme: 'YYYY-MM-DD' },
      { charset: 'UTF-8' }
    ]);

    $(document).ready(function () {
      $('.carousel').carousel({ interval: 2000, cycle: true });
    });

    AOS.init();
    this.language = localStorage.getItem('language');
    console.log(this.language, "Overview com");

    // if (this.language == 'od' || this.language == 'kn') {
    //   this.language = 'en';
    // } else {
    //   this.language = this.language;
    // }

    this.translateService.setDefaultLang(this.language);

    this.translateService.get(["members"]).subscribe(values => {
      var data = Object.keys(values).map(key => values[key]);
      this.internalization = data[0];
      console.log(this.internalization)
    });
    if (this.language == 'hn') {
      this.pressReleaseNotes = [
        {
          id: 15,
          img: "./../../../assets/news-media/press/15.jpg",
          imgList: [
          ],
          note: "बेंगलुरु में केएसए ऑफिसर्स कॉलोनी और बैंक ऑफिसर्स",
          dt: "06.06.25",
          moreContent: [
            {
              nm: "बेंगलुरु में केएसए ऑफिसर्स कॉलोनी और बैंक ऑफिसर्स कॉलोनी के लिए पीएनजी (पाइप्ड नेचुरल गैस) घरेलू आपूर्ति का आधिकारिक उद्घाटन 1 जून, 2025 को कर्नाटक सरकार के माननीय परिवहन और मुजराई मंत्री श्री रामलिंगा रेड्डी ने किया, जिन्होंने इस अवसर पर एक रसोई में चूल्हा जलाया। माननीय मंत्री ने बेंगलुरु निवासियों के दरवाजे तक स्वच्छ, सुविधाजनक और सतत ऊर्जा लाने में कंपनी के समर्पित प्रयासों के लिए गेल गैस लिमिटेड की सराहना की। श्री संजय कुमार सिंह, सीजीएम (सीजीडी) और ओआईसी ने पीएनजी और गेल गैस की शहर भर में बढ़ती पहुंच के लाभों पर विचार साझा किए, निवासियों के प्रश्नों का उत्तर दिया और व्यापक रूप से अपनाए जाने के लिए प्रोत्साहित किया।"
            }
          ]
        },
        {
          id: 16,
          img: "./../../../assets/news-media/press/16.jpg",
          imgList: [
          ],
          note: "गेल गैस लिमिटेड ने 27 मई, 2025 को अपना 18वां स्थापना दिवस मनाया",
          dt: "06.06.25 ",
          moreContent: [
            {
              nm: "गेल गैस लिमिटेड ने 27 मई, 2025 को अपना 18वां स्थापना दिवस मनाया। सिर्फ चार शहरों में परिचालन से, गेल गैस ने अब नौ राज्यों में 16 भौगोलिक क्षेत्रों तक अपनी पहुंच का विस्तार किया है। आने वाले दिनों में, कंपनी देश भर में अधिक घरों, उद्योगों और वाहनों तक स्वच्छ, पर्यावरण अनुकूल प्राकृतिक गैस पहुंचाने के अपने मिशन को तेज करने के लिए पहले से कहीं अधिक प्रेरित है!"
            },
             
          ]
        }        
        
      ];
      this.eoiTableData().subscribe((res: any) => {
        console.log(res['eoi']);

        this.EOI1 = res['eoi'][0].notice_nm;
        this.EOI2 = res['eoi'][1].notice_nm;
        this.EOI3 = res['eoi'][2].notice_nm;
        this.EOI4 = res['eoi'][3].notice_nm;
      });
    } else {
      this.pressReleaseNotes = [
        {
          id: 15,
          img: "./../../../assets/news-media/press/15.jpg",
          imgList: [
          ],
          note: "The PNG (Piped Natural Gas) domestic supply for KSA Officers Colony & Bank Officers",
          dt: "06.06.25",
          moreContent: [
            {
              nm: "The PNG (Piped Natural Gas) domestic supply for KSA Officers Colony & Bank Officers Colony in Bengaluru was officially inaugurated on 1st June, 2025 by Shri Ramalinga Reddy, Hon’ble Minister of Transport & Muzrai, Government of Karnataka, who lit a stove in one of the kitchens to mark the occasion. Hon’ble Minister lauded GAIL Gas Limited for the company's dedicated efforts in bringing clean, convenient, and sustainable energy to the doorsteps of Bengaluru residents. Shri Sanjay Kumar Singh, CGM (CGD) & OIC shared insights on the benefits of PNG and GAIL Gas’ expanding reach across the city, addressing residents’ queries and encouraging widespread adoption."
            }
          ]
        },
        {
          id: 16,
          img: "./../../../assets/news-media/press/16.jpg",
          imgList: [
          ],
          note: "GAIL Gas Limited celebrated its 18th Foundation Day on 27th May, 2025.",
          dt: "06.06.25 ",
          moreContent: [
            {
              nm: "GAIL Gas Limited celebrated its 18th Foundation Day on 27th May, 2025. From operating in just four cities, GAIL Gas has now expanded our reach to 16 geographical areas across nine states. In the coming days, the company is more motivated than ever to accelerate its mission of bringing clean, environment-friendly natural gas to more homes, industries and vehicles across the nation!"
            },
            // {
            //   nm: "The machines were handed over for public service by Shri Tejasvi Surya Hon’ble Member of Parliament, Bengaluru South, on 21st May, 2025 in the presence of CGM (CGD) & OIC, GAIL Gas Limited, Bengaluru, the Health Officer, BBMP, and CSR Committee members of GAIL Gas Limited."
            // },
            // {
            //   nm: "This initiative is a step towards sustainable development and inclusive healthcare, reaffirming GAIL Gas Limited’s commitment to improving the quality of life through affordable health care along with its various offering of PNG & CNG."
            // },
          ]
        }

      ];
      // {
      //   id: 2,
      //   img: "./../../../assets/news-media/press/press-release-one-1.jpg",
      //   imgList: [{
      //     img: './../../../assets/news-media/press/press-release-one-1.jpg'
      //   }, {
      //     img: './../../../assets/news-media/press/press-release-one-2.jpg'
      //   }, {
      //     img: './../../../assets/news-media/press/press-release-one-3.jpg'
      //   }, {
      //     img: './../../../assets/news-media/press/press-release-one-4.jpg'
      //   }, {
      //     img: './../../../assets/news-media/press/press-release-one-5.jpg'
      //   }, {
      //     img: './../../../assets/news-media/press/press-release-one-6.jpg'
      //   }],
      //   note: "Community Centre & Kalyan Mandap inaugurated by Hon’ble Union Minister of Petroleum and Natural Gas & Steel Shri Dharmendra Pradhan",
      //   dt: "28.02.21",
      //   moreContent: [{
      //     nm: "Puri (Odisha), February 28, 2021: With an objective to facilitate the basic amenities & improve the lifestyle of the residents in Puri, under CSR initiative of GAIL Gas Limited, Community Centre, Jhadeswari Club and Kalyan Mandap, Baseli Sahi was inaugurated today by Hon’ble Union Minister of Petroleum and Natural Gas & Steel Shri Dharmendra Pradhan. Hon’ble MLA of Puri, Shri Jayanta Kumar Sarangi, Hon’ble MLA Brahmagiri Shri Lalitendu Vidyadhar Mahopatra, Shri Sambit Patra, BJP Spokesperson; Shri Partha Sarathi Mohopatra, President Jhadeshwari Club, Shri Krushna Chandra Das, Secretary, Jhadeswari Club, Shri MP Chaudhari, CMD, MOIL, Shri K.B Singh, Executive Director GAIL (India) Limited and Shri M. V Ravi Someswarudu, CEO, GAIL Gas were also present at the occasion."
      //   }, {
      //     nm: "The construction of Community Centre, Jhadeswari Club and renovation and development Kalyan Mandap, Baseli Sahi was done by GAIL Gas Limited under its Corporate Social Responsibility (CSR) initiative at an investment of Rs. 40.4 lakh. The other projects are  Construction of 20 seated Community Toilet at Paranolia Sahi, Renovation and Development of public water bodies at Mangala Ghat, Construction of Community Centre  at Jagannath Basti. The total cost of the CSR projects is around Rs 92 lakhs. These projects are undertaken through an NGO M/s Gramya Prava.."
      //   }]
      // }

      this.eoiTableData().subscribe((res: any) => {
        console.log(res['eoi']);

        this.EOI1 = res['eoi'][0].notice_nm;
        this.EOI2 = res['eoi'][1].notice_nm;
        this.EOI3 = res['eoi'][2].notice_nm;
        this.EOI4 = res['eoi'][3].notice_nm;
      });
    }

    if (this.pressReleaseNotes.length >= 2) {
      // this.pressReleaseNotesUpdated.push(this.pressReleaseNotes[1]);
      this.pressReleaseNotesUpdated.push(this.pressReleaseNotes[0], this.pressReleaseNotes[1]);
    }
    console.log(this.pressReleaseNotesUpdated);

  }

  getEoiDetails() {
    this.service.get_Eoi_Detaiols_Fun({}).subscribe((res: any) => {
      if (res.code == 200) {
        let data = res.data
        this.EOIData = []
        for (let i = 0; i < 5; i++) {
          this.EOIData.push(data[i].Notice)
        }
        // console.log(data)
        // console.log(this.EOIData)
      }
    })
  }

  sahajUrl() {
    window.open('https://admin.gailgaspng.com', '_blank');
  }

  savingsCalculator(event) {
    this.router.navigate(['/calculator/savings-calculator'], { state: { tabIndex: event } });
  }

  pressReleaseEvent(event) {
    if (event == 'more') {
      if (this.language == 'hn') {
        this.router.navigate(['/news-media/media-events-hn'], { state: { activity: undefined } });
      } else {
        this.router.navigate(['/news-media/media-events'], { state: { activity: undefined } });
      }
    } else {

      console.log(event);
      if (this.language == 'hn') {
        this.router.navigate(['/news-media/media-events-hn'], { state: { activity: event.id } });
      } else {
        this.router.navigate(['/news-media/media-events'], { state: { activity: event.id } });
      }

    }
  }

  cngOutletRoute(event) {
    console.log(event);
    if (this.language == 'hn') {
      this.router.navigate(['/products/cng-hn'], { state: { activityNew: event } });
    } else {
      this.router.navigate(['/products/cng'], { state: { activityNew: event } });
    }
  }

  eoiTableData() {
    if (this.language == "hn") {
      return this.http.get('https://gailgaspdfdownloads.s3.ap-south-1.amazonaws.com/eoi_hn.json');
    }
    if (this.language == "en") {
      return this.http.get('https://gailgaspdfdownloads.s3.ap-south-1.amazonaws.com/eoi.json');
    }
  }
}
